import React from "react";
import styled from "styled-components";
import Box from "../../UI/Box";
import bg from "../../images/PROFILEINFO.png";
import userimg from "../../images/user.webp";
import { UseAuthContext } from "../../store/contexts/auth.context";
import { UsePostsContext } from "../../store/contexts/posts.context";
import { NavLink, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useState } from "react";

function ProfileInfo({ column = false, userData = null, post_id = null }) {
  const { data, posts } = UseAuthContext();
  const { deletePost, getAuthor } = UsePostsContext();
  const [user, setuser] = useState();
  const navigate = useNavigate();
  useEffect(() => {
    if (userData) {
      setuser(userData);
    } else {
      setuser(data);
    }
  }, [userData]);
  const deleteHandler = async () => {
    await deletePost(post_id);
    navigate("/");
  };
  return (
    <Box>
      <Wrapper className={`${column ? "column" : ""}`}>
        <div className="image">
          <div
            style={{
              backgroundImage: `url(${
                user?.account_image_path?.String || userimg
              })`,
            }}
          />
        </div>
        {column && user?.id === data.id && (
          <>
            <div className="flex">
              <input
                type="button"
                style={{ background: "#9e1616" }}
                className="form-input"
                value={"Delete"}
                onClick={deleteHandler}
              />
              <input
                // disabled
                style={{ opacity: "0.5" }}
                type="button"
                className="form-input"
                value={"Edit"}
                onClick={() => navigate(`/add-post?id=${post_id}`)}
              />
            </div>
          </>
        )}
        <div className="info">
          <h1 className="article-title">
            {user?.first_name} {user?.second_name || "Unset"}
          </h1>
          <NavLink to={`/profile/${user?.id}`}>
            <h2>@{user?.nickname}</h2>
          </NavLink>
          <p>{user?.bio || "Unset"}</p>
        </div>
        <div className="social-media">
          <h2>Contacts</h2>
          <a target={"_blank"} href={`tel:${data.phone}`}>
            <p className="flex start" href={`tel:${user?.phone}`}>
              <img src="https://img.icons8.com/color/48/undefined/apple-phone.png" />
              {user?.phone || "Unset"}
            </p>
          </a>
          <a target={"_blank"} href={`mailto:${user?.email}`}>
            <p className="flex start">
              <img src="https://img.icons8.com/color/48/undefined/gmail-new.png" />
              {user?.email || "Unset"}
            </p>
          </a>
          <a
            target={"_blank"}
            href={`https://www.google.com/maps/search/${user?.city}`}
          >
            <p className="flex start">
              <img src="https://img.icons8.com/color/48/undefined/marker--v1.png" />
              {user?.city || "Unset"}
            </p>
          </a>
        </div>
        <div className="bg" style={{ backgroundImage: `url(${bg}` }} alt="" />
      </Wrapper>
    </Box>
  );
}

export default ProfileInfo;
const Wrapper = styled.div`
  padding: 40px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 80px;
  @media (max-width: 1199px) {
    gap: 50px;
  }
  @media (max-width: 992px) {
    flex-wrap: wrap;
    & > .image {
      flex: 0 0 100% !important;
      max-width: 150px !important;
      margin: 0 auto;
    }
  }
  @media (max-width: 767px) {
    flex-direction: column;
    padding: 30px;
    & > .image {
      flex: 0 0 150px !important;
      max-width: 150px !important;
      margin: 0 auto;
    }
    & > * {
      flex: 0 0 100% !important;
      max-width: 100% !important;
    }
  }

  &.column {
    flex-direction: column;
    align-items: center;
    gap: 40px;
    .image {
      aspect-ratio: 1/1;
      max-width: 150px;
      background-color: #acafb3;
      border-radius: 50%;
    }
  }
  p {
    font-size: 1rem;
    gap: 10px;
    transition: all 0.3s;
    &:hover {
      gap: 16px;
    }
    img {
      width: 24px;
    }
  }
  .social-media {
    max-width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    h2 {
      margin-bottom: 24px;
    }
    a,
    p {
      width: 100%;
      margin-top: 10px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    a {
      max-width: 100%;
      display: block;
    }
  }
  .bg {
    width: 100%;
    height: 100%;
    background-size: auto;
    background-repeat: repeat;
    background-size: 11rem;
    position: absolute;
    opacity: 0.05;
    top: 0px;
    left: 0px;
    z-index: 0;
    border-radius: 1rem;
  }
  .info {
    max-width: 40%;
    min-width: 40%;
    @media (max-width: 992px) {
      max-width: 51%;
    }
  }
  & > * {
    position: relative;
    z-index: 2;
  }
  .image {
    width: 100%;
    height: 150px;
    flex: 0 0 150px;
    div {
      width: 100%;
      height: 100%;
      border-radius: 50%;
      background-size: cover;
      background-position: center;
      transform: translate(-0px, -0px);
      z-index: 2;
    }
    position: relative;
    z-index: 3;
    &::after {
      position: absolute;
      bottom: -10px;
      right: -10px;
      width: 100%;
      border-radius: 50% 10%;
      height: 100%;
      content: "";
      background-color: #71809673;
      z-index: -1;
    }
  }
`;
